import React from 'react';
import AuthProvider from './containers/AuthProvider/AuthProvider';
import Layout from './components/Layout/Layout';
import Projects from './containers/Projects/Projects';
import Create from './containers/Create/Create';
import Project from './components/Project/Project';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Home from "./containers/Home/Home";
import Docs from "./containers/Docs/Docs";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Layout>
          <Switch>
            <Route exact path="/" component={Home} />
            <Route exact path="/create" component={Create} />
            <Route exact path="/docs" component={Docs} />
            <Route exact path="/projects" component={Projects} />
            <Route exact path="/project/:id" component={Project} />
            <Route exact path='*' component={Projects} />
          </Switch>
        </Layout>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
